import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import {projectName} from "@/utils/config";

export default [
  {
    path: '/IFPageOneHNinePreLogin',
    name: 'IFPageOneHNinePreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHNine/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageOneHNineLogin' || from.path === '/IFPageOneHNineLoginSecond') {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHNineLogin',
    name: 'pageOneHNineLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHNine/login.vue'),
  },
  {
    path: '/IFPageOneHNineLeaveInfo',
    name: 'pageOneHNineLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHNine/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHNineResult',
    name: 'pageOneHNineResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHNine/result.vue'),
  },
  {
    path: '/IFPageOneHNineLoading',
    name: 'pageOneHNineLoading',
    component: () => import('@/pages/pageListAll/pageOneHNine/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHNineLoginSecond',
    name: 'pageOneHNineLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHNine/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHNineOnline',
    name: 'pageOneHNineOnline',
    component: () => import('@/pages/pageListAll/pageOneHNine/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHNineLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHNineGuide',
    name: 'pageOneHNineLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHNine/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHNineCar',
    name: 'pageOneHNineCar',
    component: () => import('@/pages/pageListAll/pageOneHNine/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHNineCarDetails',
    name: 'pageOneHNineCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHNine/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHNineBlank',
    name: 'pageOneHNineBlank',
    component: () => import('@/pages/pageListAll/pageOneHNine/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHNineOnlineTab',
    name: 'pageOneHNineOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHNine/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
];
